import Box from '@mui/material/Box';
import * as React from 'react';
import Typography from '@mui/material/Typography';

export default function IntroBlurb() {
    return (
        <>
            <Box>
                <Typography variant='h4' fontFamily='Proxima Nova' gutterBottom>
                    <b>Purpose</b>
                </Typography>
                <Typography variant='body2' fontFamily='Proxima Nova' gutterBottom>
                    The Theta Tau Psi Delta Chapter is more than just a student group or club. As a professional fraternity, 
                    our Brothers unite over their interest in engineering and form bonds stronger than friendship. At our 
                    core are our three pillars: <b>Service, Profession, and Brotherhood</b>. These pillars serve to <b>inspire 
                    our members to be ethical, responsible, and civic-minded engineers</b> throughout their time as 
                    undergraduates and beyond. 
                    <br></br><br></br>
                    Brothers of Theta Tau are upstanding members of their communities where they are involved in more 
                    than just their academics and truly strive to improve the lives of others through activities such as mentorship 
                    programs or even just tutoring friends. Theta Tau provides a supportive environment for undergraduate 
                    engineers and an impressive professional network for the years after graduation. 
                ​</Typography>
            </Box>
        </>
    );
  }